import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IElevatedFileService = ( createDecorator('elevatedFileService'));
export { IElevatedFileService };
